import { render, staticRenderFns } from "./ApprEdit.vue?vue&type=template&id=f931315e&scoped=true&"
import script from "./ApprEdit.vue?vue&type=script&lang=js&"
export * from "./ApprEdit.vue?vue&type=script&lang=js&"
import style0 from "./ApprEdit.vue?vue&type=style&index=0&id=f931315e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f931315e",
  null
  
)

export default component.exports